// src/hooks/useTimer.js
import { useEffect, useRef } from 'react';

const useTimer = ({ isActive, onTick, onComplete, interval = 1000 }) => {
  const savedCallback = useRef();
  const intervalId = useRef();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = () => {
      onTick();
    };
  }, [onTick]);

  // Setup the interval
  useEffect(() => {
    if (isActive) {
      intervalId.current = setInterval(() => {
        if (savedCallback.current) {
          savedCallback.current();
        }
      }, interval);
    }

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [isActive, interval]);

  // Handle completion if needed
  useEffect(() => {
    if (!isActive && onComplete) {
      onComplete();
    }
  }, [isActive, onComplete]);
};

export { useTimer };